'use client'
// Comparison as a toggle: one tab per option, the active option's text at full reading width.
// Every option stays in the HTML (search, verbatim audit); inactive panels are hidden.
import React, { useId, useRef, useState } from 'react'

export type OptionItem = { name: string; sub?: string | null; html: string }

export function OptionTabs({ items, size = 'prose' }: { items: OptionItem[]; size?: 'prose' | 'support' }) {
  const [active, setActive] = useState(0)
  const base = useId()
  const tabs = useRef<(HTMLButtonElement | null)[]>([])
  if (!items.length) return null
  const onKey = (e: React.KeyboardEvent, i: number) => {
    const n = items.length
    const to = e.key === 'ArrowRight' ? (i + 1) % n : e.key === 'ArrowLeft' ? (i - 1 + n) % n : -1
    if (to < 0) return
    e.preventDefault()
    setActive(to)
    tabs.current[to]?.focus()
  }
  return (
    <div className="hb-opt">
      <div className="hb-tabs" role="tablist" aria-label="Options">
        {items.map((x, i) => (
          <button
            key={x.name}
            ref={(el) => { tabs.current[i] = el }}
            type="button"
            role="tab"
            id={`${base}-t${i}`}
            aria-selected={i === active}
            aria-controls={`${base}-p${i}`}
            tabIndex={i === active ? 0 : -1}
            className="hb-tab"
            onClick={() => setActive(i)}
            onKeyDown={(e) => onKey(e, i)}
          >
            {x.name}
          </button>
        ))}
      </div>
      {items.map((x, i) => (
        <div key={x.name} role="tabpanel" id={`${base}-p${i}`} aria-labelledby={`${base}-t${i}`} hidden={i !== active} className={`hb-opt-panel hb-opt-${size}`}>
          {x.sub ? <p className="hb-opt-sub">{x.sub}</p> : null}
          <div dangerouslySetInnerHTML={{ __html: x.html }} />
        </div>
      ))}
    </div>
  )
}
